<template>
  <div>
    <el-row>
      <h5>产品：{{ 产品信息.NAME}}</h5>
    </el-row>
    <el-row>
      <el-col>
        <el-button size="medium" @click="上传凭证()">上传凭证</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3" style="margin-top:20px" v-for="(item, index) in tableData" :key="index">
        <el-card :body-style="{ padding: '0px' }" style="margin-left:10px">
          <img :src=" 图片拼接路径 + item.URL" class="image" style="height:200px">
          <div style="padding: 14px;">
            <div class="bottom clearfix">
              <div>
                <span style="font-size:10px">资质名称：{{ item.NAME }}</span>
                <span style="font-size:10px">过期日期：{{ item.END_DAY }}</span>
              </div>
              <el-button size="medium" type="text" class="button" @click="openImage(item.URL)">查看大图</el-button>
              <el-button size="medium" type="text" class="button" @click="修改(item)">修改</el-button>
              <el-button size="medium" type="text" class="button" @click="deleteImg(item.ID)">删除</el-button>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-dialog :visible.sync="dialogVisible" :before-close="handleClose">
      <img :src="this.imgUrl" style="width:100%">
    </el-dialog>
    <el-dialog :visible.sync="修改资质模态框" title="修改资质凭证" @close="修改资质模态框 = false" width="450px" center>
      <el-form ref="修改表单" v-model="修改表单" :label-width="formLabelWidth">
        <el-form-item label="资质名称：">
          <el-input v-model="修改表单.NAME" style="width:250px"> </el-input>
        </el-form-item>
        <el-form-item label="日期范围：">
          <el-date-picker v-model="修改表单.DAY_INTERVAL" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width:250px"></el-date-picker>
        </el-form-item>
        <el-form-item label="产品资质：">
          <el-upload class="upload-demo" action="/uploadFile" :on-success="handleSuccess" :name="'qualification'" :file-list="fileList">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button class="operate-btn" @click="修改资质模态框 = false">取消</el-button>
        <el-button class="operate-btn" @click="确认修改资质()">确认</el-button>
      </div>
    </el-dialog>

    <el-row>
      <el-col>
        <el-dialog :visible.sync="上传资质凭证模态框" title="上传资质凭证" @close="上传资质凭证模态框 = false" width="450px" center>
          <el-form ref="addForm" v-model="addForm" :label-width="formLabelWidth">
            <el-form-item label="资质名称：">
              <el-input v-model="addForm.NAME" style="width:250px"> </el-input>
            </el-form-item>
            <el-form-item label="日期范围：">
              <el-date-picker v-model="addForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width:250px"></el-date-picker>
            </el-form-item>
            <el-form-item label="产品资质：">
              <el-upload class="upload-demo" action="/uploadFile" :on-success="handleSuccess" :name="'qualification'" :file-list="fileList">
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </el-form-item>
          </el-form>
          <div slot="footer" style="text-align: center;">
            <el-button class="operate-btn" @click="上传资质凭证模态框 = false">取消</el-button>
            <el-button class="operate-btn" @click="确认上传资质()">确认</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>
  </div>
</template>
<script>


import http from '@/assets/common/http';

export default {
  data() {
    return {
      图片拼接路径: '',
      tableData: [],
      修改资质模态框: false,
      上传资质凭证模态框: false,
      addForm: {
        image: 'qualification',
        NAME: '',
      },
      修改表单: {
      },
      formLabelWidth: '120px',
      file_name: '',
      fileList: [],
      产品信息: JSON.parse(sessionStorage.getItem('常用SKU当前行信息')),
      产品名称: sessionStorage.getItem('产品名称'),
      QUALIFICATION: [],
      url: '',
      dialogVisible: false,
      imgUrl: '',
      pdfImage: require('../../assets/common/image/404_images/pdf.png'),
      wordImage: require('../../assets/common/image/404_images/word.png'),
      unknowImage: require('../../assets/common/image/404_images/unknow.png'),
    };
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    deleteImg(e) {
      const params = {
        ID: e,
        SERVICE_ID: '100271',
        OTYPE: 6,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '删除成功', type: 'success' });
        this.拉取资质();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    修改(item) {
      this.修改资质模态框 = true;
      this.修改表单 = { ...item };
      this.修改表单.DAY_INTERVAL = [item.BEGIN_DAY, item.END_DAY];
    },
    openImage(e) {
      this.dialogVisible = true;
      this.imgUrl = this.图片拼接路径 + e;
    },
    handleSuccess(response, file, fileList) {
      this.url = `qualification/${response.file_name}`;
    },
    handleRemove(file, fileList) {
      this.url = '';
    },
    上传凭证() {
      this.上传资质凭证模态框 = true;
    },
    确认修改资质() {
      if (!this.url) {
        this.$message.show({ text: '请上传文件', type: 'warning' });
        return false;
      }
      if (!this.修改表单.NAME) {
        this.$message.show({ text: '请输入资质名称', type: 'warning' });
        return false;
      }
      if (!(this.修改表单.DAY_INTERVAL && this.修改表单.DAY_INTERVAL[0])) {
        this.$message.show({ text: '请选择日期范围', type: 'warning' });
        return false;
      }
      const params = {
        ID: this.修改表单.ID,
        SERVICE_ID: '100271',
        OTYPE: 5,
        NAME: this.修改表单.NAME,
        URL: this.url,
        BEGIN_DAY: this.修改表单.DAY_INTERVAL[0],
        END_DAY: this.修改表单.DAY_INTERVAL[1],
      };
      http.post(params)
        .then((result) => {
          this.$message.show({ text: '修改成功', type: 'success' });
          this.修改资质模态框 = false;
          this.修改表单 = [];
          this.url = '';
          this.fileList = [];
          this.拉取资质();
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    确认上传资质() {
      if (!this.url) {
        this.$message.show({ text: '请上传文件', type: 'warning' });
        return false;
      }
      if (!this.addForm.NAME) {
        this.$message.show({ text: '请输入资质名称', type: 'warning' });
        return false;
      }
      if (!(this.addForm.DAY_INTERVAL && this.addForm.DAY_INTERVAL[0])) {
        this.$message.show({ text: '请选择日期范围', type: 'warning' });
        return false;
      }
      const params = {
        SUPPLIER_USING_ID: this.产品信息.ID,
        SERVICE_ID: '100271',
        OTYPE: 4,
        NAME: this.addForm.NAME,
        URL: this.url,
        BEGIN_DAY: this.addForm.DAY_INTERVAL[0],
        END_DAY: this.addForm.DAY_INTERVAL[1],
      };
      http.post(params)
        .then((result) => {
          this.$message.show({ text: '新增成功', type: 'success' });
          this.上传资质凭证模态框 = false;
          this.addForm = [];
          this.url = '';
          this.fileList = [];
          this.拉取资质();
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    拉取资质() {
      const params = {
        SUPPLIER_USING_ID: this.产品信息.ID,
        SERVICE_ID: '100271',
        OTYPE: 7,
      };
      http.post(params)
        .then((result) => {
          if (result.length !== 0) {
            this.tableData = result;
          } else {
            this.tableData = [];
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
  },
  beforeRouteLeave(to, from, next) {
    sessionStorage.removeItem('常用SKU当前行信息');
    next();
  },
  created() {
    this.拉取资质();
    this.图片拼接路径 = `${this.$util.getURLLocalHost('')}/file/`;
  },
};
</script>
<style>
.image {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/SKUManage/productQualification.vue